import { saveBlob } from 'helper/downloadFile';
import { handleApiError } from 'helper/error';
import { sendInterfaceErrorToSentry } from 'helper/sendErrorToSentry';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { ResponseError } from 'services/api/base';

export const DOWNLOAD_ERROR_MESSAGE = 'Não foi possível baixar o arquivo. Verifique sua conexão e tente novamente.';

export default function useFileDownloadApi<ParamsType>({
  blobDownloader,
  params,
  filename,
}: {
  blobDownloader: (params: ParamsType) => Promise<Blob | ResponseError>,
  params: ParamsType,
  filename: string,
}) {
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  async function onClick() {
    setLoading(true);
    setError(null);

    try {
      const blob = await blobDownloader(params);

      if (!(blob instanceof Blob)) {
        handleApiError(navigate, blob);
        return;
      }

      saveBlob(blob, filename);
    } catch (e) {
      // Rede caiu no meio, timeout ou status HTTP fora de 2xx (o axios lança). É falha de um
      // download, não da aplicação: o usuário fica na página, com o aviso, e pode tentar de novo.
      setError(DOWNLOAD_ERROR_MESSAGE);
      sendInterfaceErrorToSentry('Falha no download de arquivo', filename, e, {
        fingerprint: ['file-download-failed'],
      });
    } finally {
      setLoading(false);
    }
  }

  return {
    isLoading,
    error,
    clearError: () => setError(null),
    onClick,
  };
}
